<template>
  <v-dialog :value="true" max-width="800" persistent>
    <v-card>
      <v-card-title>{{ isNew ? "Nuevo envío" : "Editar envío" }}</v-card-title>
      <v-card-text>
        <v-text-field v-model="form.name" label="Nombre" />

        <v-autocomplete
          v-model="form.tags"
          :items="tags"
          item-text="name"
          item-value="_id"
          :label="resx.labels.tags"
          multiple
          chips
          deletable-chips
        />
        <div class="body-2 grey--text mb-2">
          Entran todas las obligaciones con estas etiquetas, estén vencidas o no.
        </div>

        <div class="body-2 mt-4 mb-2">Día de envío</div>
        <schedule-selector
          v-model="form.schedule"
          :allowed="['dayOfMonth', 'lastDay', 'lastBusinessDay']"
        />

        <email-list
          v-model="form.recipientEmails"
          label="Direcciones que reciben este envío"
        />
        <div class="body-2 grey--text">
          Este envío no le llega a las contratistas: es un reporte interno.
        </div>

        <div class="body-2 mt-4 mb-1">Texto del correo</div>
        <vue-editor v-model="form.bodyHtml" :editor-toolbar="editorToolbar" />

        <v-switch
          v-model="form.isActive"
          color="primary"
          :label="`Envío ${form.isActive ? 'activo' : 'inactivo'}`"
        />

        <v-alert v-if="errorMessage" type="error" dense text>{{ errorMessage }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')">{{ resx.labels.cancel }}</v-btn>
        <v-btn class="primary" @click="save">{{ resx.labels.ok }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import { VueEditor } from "vue2-editor";
import tagsService from "@/services/TagsService";
import scheduleSelector from "./schedule-selector.component.vue";
import emailList from "./email-list.component.vue";

const emptyForm = () => ({
  name: "",
  tags: [],
  schedule: { dayType: "dayOfMonth", dayOfMonth: 1 },
  recipientEmails: [],
  bodyHtml: "",
  isActive: true,
  isDeleted: false
});

export default {
  name: "tag-mailing-dialog",
  components: {
    VueEditor,
    "schedule-selector": scheduleSelector,
    "email-list": emailList
  },
  props: {
    tagMailing: { type: Object, default: null }
  },
  data() {
    return {
      // Copia profunda: hasta que no se acepte el modal, la empresa no se toca.
      form: this.tagMailing ? JSON.parse(JSON.stringify(this.tagMailing)) : emptyForm(),
      tags: [],
      errorMessage: null,
      editorToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ]
    };
  },
  computed: {
    isNew() {
      return !this.tagMailing;
    }
  },
  async mounted() {
    try {
      this.tags = await tagsService.list();
    } catch (error) {
      this.errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        "No se pudieron cargar las etiquetas";
    }
    // Las etiquetas llegan como ids o como objetos segun si el backend populo.
    this.form.tags = (this.form.tags || []).map(t => (typeof t === "string" ? t : t._id));
  },
  methods: {
    save() {
      if (!this.form.name || !this.form.name.trim()) {
        this.errorMessage = "El nombre es obligatorio";
        return;
      }
      if (!this.form.tags.length) {
        this.errorMessage = "Elegí al menos una etiqueta";
        return;
      }
      // Sin destinatarios el envio no tiene a donde ir y el planificador ni
      // siquiera lo considera. Se corta aca para que nadie deje configurado un
      // envio que no sale nunca sin entender por que.
      if (!this.form.recipientEmails.length) {
        this.errorMessage = "Cargá al menos una dirección";
        return;
      }
      this.errorMessage = null;
      this.$emit("save", this.form);
    }
  }
};
</script>
